// extracted by mini-css-extract-plugin
module.exports = {"notStore":"_2hzE8","prodInfo":"_2JQUg","infoRight":"_10a6q","link":"_1Lv2r","supplier":"_1bYJ8","price":"_2lYIO","footer":"jeQiU","comment":"_2GZ80"};